import { Login } from '../Login'
import ScheduleContextProvider from '../ScheduleContext'
import UserContext from '../UserContext'
import { Websocket } from '../Websocket'
import { EnterApp } from './EnterApp'

// Öffentliche Startseite mit Login; eingeloggte Benutzer werden ins Portal unter /app weitergeleitet
export const PortalEntry = () => {
  return (
    <Websocket>
      <ScheduleContextProvider>
        <UserContext loggedOut={<Login />}>
          <EnterApp />
        </UserContext>
      </ScheduleContextProvider>
    </Websocket>
  )
}
